import { render, staticRenderFns } from "./publicCard.vue?vue&type=template&id=7857820c&scoped=true"
import script from "./publicCard.vue?vue&type=script&lang=ts"
export * from "./publicCard.vue?vue&type=script&lang=ts"
import style0 from "./publicCard.vue?vue&type=style&index=0&id=7857820c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7857820c",
  null
  
)

export default component.exports